export class Conditionnement {
    static jsonMap = {
        id: 'id',
        code: 'code',
        libelle: 'libelle'
    };

    id: number = undefined;
    code: string = undefined;
    libelle: string = undefined;
}
